import { Component } from '@angular/core';
import {environment} from "../../environments/environment";

@Component({
  selector: 'app-contact-us',
  standalone: true,
  imports: [],
  templateUrl: './contact-us.component.html',
  styleUrl: './contact-us.component.scss'
})
export class ContactUsComponent {
  logo = '';
  isPyrocast = true;
	ignite = false;
	constructor() {
		if(window.location.hostname == environment.skyDomain){
			this.logo = 'skystream_logo.png';
			this.isPyrocast = false;
			this.ignite = false;
		}
		else if(window.location.hostname == environment.igniteDomain){
			this.logo = 'IGNITE_Live_Logo_login_page.png';
			this.isPyrocast = false;
			this.ignite = true;
		}
		else if(window.location.hostname == environment.tune2Domain || window.location.hostname == environment.tune2Domain2){
			this.logo = 'tune2-logo.webp';
			this.isPyrocast = false;
			this.ignite = false;
		}
		else{
			this.logo = 'pyrocast-logo-new.webp';
		}
	}
}
